import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';
import PhoneCallsRightSidebar from './sideBar/PhoneCallsRightSidebar';

const PhoneCallsPage = lazyRetry(() => import('./PhoneCallsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('phonecalls'),
	routes: [
		{
			path: 'phonecalls/list',
			auth: ({ authorizer }) => authorizer.can('view', 'phonecalls'),
			element: <PhoneCallsPage getRightSidebarSections={PhoneCallsRightSidebar} />
		}
	]
};

export default routes;
